import { useSearchParams } from "react-router-dom";
import CustomCreditQueryReview from "../components/queries/CustomCreditQueryReview";
import CustomVehicleQuery from "../components/queries/CustomVehicleQuery";
import axios from "axios";
import { BASE_URL } from "../config/apiConfig";
import { useQuery } from "react-query";
import { useEffect } from "react";
import CustomVehicleQueryReview from "../components/queries/CustomVehicleQueryReview";
import CustomCadastralQueryReview from "../components/queries/CustomCadastralQueryReview";

const ReviewQuery = () => {
  const [searchParams] = useSearchParams();
  const queryId = searchParams.get("queryId");
  const categoryId = searchParams.get("categoryId");
  const parameter = searchParams.get("parameter");
  const companyId = searchParams.get("companyId");
  const hasHeaderPDF = searchParams.get("hasHeaderPDF");

  const { data, isLoading, error } = useQuery(
    ["queryReview", { queryId, categoryId, parameter, companyId }],
    async () => {
      const response = await axios.get(BASE_URL + "/user-query-id", {
        params: {
          queryId,
          parameter,
          companyId,
        },
      });
      return response.data.data.id;
    },
    {
      enabled: !!queryId && !!parameter,
    }
  );

  useEffect(() => {
    if (!isLoading && data) {
      window.documentReady = true;
    }
  }, [isLoading, data]);

  if (isLoading) return <div className="p-4">Carregando...</div>;
  if (error || !data)
    return (
      <div className="p-4 text-red-600">
        Erro ao carregar dados da consulta.
      </div>
    );

  return (
    <div id="review-query" className="bg-white h-screen">
      {data ? (
        <>
          {categoryId === "1" && (
            <CustomCreditQueryReview
              isReviewOpen={true}
              hashasHeaderPDF={hasHeaderPDF === "true" ? true : false}
              query={{ id: data }}
              hasPrintButton={true}
            />
          )}
          {categoryId === "2" && (
            <CustomCadastralQueryReview
              isReviewOpen={true}
              hasHeaderPDF={hasHeaderPDF === "true" ? true : false}
              query={{ id: data }}
              hasPrintButton={true}
            />
          )}
          {categoryId === "3" && (
            <CustomVehicleQueryReview
              isReviewOpen={true}
              hasHeaderPDF={hasHeaderPDF === "true" ? true : false}
              query={{ id: data }}
              hasPrintButton={true}
            />
          )}
        </>
      ) : (
        <div>
          A consulta não está mais disponível para visualização em nossa base de
          dados, possivelmente por ter ultrapassado o período de retenção (7
          dias) ou por políticas de conformidade. Se precisar reavaliar,
          recomendamos gerar uma nova consulta.
        </div>
      )}
    </div>
  );
};

export default ReviewQuery;
